import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { LocaleConfig } from 'ngx-daterangepicker-material';

@Component({
  selector: 'ds365-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  standalone: false,  
})
export class DateRangePickerComponent implements OnInit {

  @Input() group!: FormGroup;
  @Input() fromDateControl!: string;
  @Input() endDateControl!: string;
  @Input() id!: string;
  @Input() placeholder = 'Select date range';
  @Input() required = false;
  @Input() timePicker = false;
  @Input() timePicker24Hour = false;
  @Input() timePickerSeconds = false;
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;

  @Output() rangeSelected = new EventEmitter<{ start: Date; end: Date }>();
  @Output() datepickerReset = new EventEmitter<void>();

  locale: LocaleConfig = {
    format: 'MM/DD/YYYY',
    displayFormat: 'MM/DD/YYYY',
    separator: ' to ',
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    clearLabel: 'Clear',
    customRangeLabel: 'Custom',
    daysOfWeek: moment.weekdaysMin(),
    monthNames: moment.monthsShort(),
    firstDay: moment.localeData().firstDayOfWeek()
  };

  ngOnInit() {
    this.updateLocaleFormat();
  }

  onRangeSelected(event: any) {
    if (!event?.startDate || !event?.endDate) return;

    const startDate = event.startDate.toDate();
    const endDate = event.endDate.toDate();

    this.group.get(this.fromDateControl)?.setValue(startDate);
    this.group.get(this.endDateControl)?.setValue(endDate);

    this.rangeSelected.emit({ start: startDate, end: endDate });
  }

  reset() {
    this.group.get('dateRange')?.reset();
    this.group.get(this.fromDateControl)?.reset();
    this.group.get(this.endDateControl)?.reset();

    this.datepickerReset.emit();
  }

  private updateLocaleFormat() {
    const format = this.timePicker ? 'MM/DD/YYYY HH:mm' : 'MM/DD/YYYY';
    this.locale.format = format;
    this.locale.displayFormat = format;
  }
}
